import { render } from "./QueryStats.vue?vue&type=template&id=4e1c9210&scoped=true"
import script from "./QueryStats.vue?vue&type=script&lang=js"
export * from "./QueryStats.vue?vue&type=script&lang=js"

import "./QueryStats.vue?vue&type=style&index=0&id=4e1c9210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1c9210"]])

export default __exports__